import { useTranslation } from "react-i18next";
import { ArrowDown, ArrowUp } from "lucide-react";
import { useAtomValue } from "jotai";
import { statsDateRangeAtom } from "@/stores/atoms/stats-date-range-atom";
import { Skeleton } from "@/components/ui/skeleton";
import { formatSuccessRate } from "@/utils/success-rate";
import { useGlobalCompletionRate } from "../hooks/useGlobalCompletionRate";

interface EvolutionStat {
  current: number | null;
  previous: number | null;
  evolution_percent: number | null;
}

const formatEvolution = (value: number | null | undefined) =>
  value === null || value === undefined || value === 0 ? "--" : `${value}%`;

const EvolutionRow = ({ stat }: { stat?: EvolutionStat }) => {
  if (!stat || stat.evolution_percent === null) return null;
  const up = (stat.previous ?? 0) < (stat.current ?? 0);
  return (
    <p className="text-sm flex items-center gap-1">
      {up ? <ArrowUp size={16} /> : <ArrowDown size={16} />}
      {formatEvolution(stat.evolution_percent)}
    </p>
  );
};

const Part2KpiCards = () => {
  const { t } = useTranslation();
  const range = useAtomValue(statsDateRangeAtom);

  const { data: completion, isLoading } = useGlobalCompletionRate({
    start_date: range.start_date,
    end_date: range.end_date,
  });

  if (isLoading) {
    return (
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }

  const noData = t("modules.stats.part2.no_data");

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* GLOBAL COMPLETION RATE */}
      <div className="p-4 bg-[#A78BFA] relative flex flex-col gap-y-2 rounded-md overflow-hidden">
        <p>{t("modules.stats.part2.completion_rate")}</p>
        <span className="text-3xl font-bold">
          {completion ? formatSuccessRate(completion.current) : noData}
        </span>
        <EvolutionRow stat={completion} />
      </div>
    </div>
  );
};

export default Part2KpiCards;
